import React, { useState, useCallback, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Clear from '@material-ui/icons/Clear'
import Button from '@material-ui/core/Button'
import DialogActions from '@material-ui/core/DialogActions'
import { useDropzone } from 'react-dropzone'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'

import componentStyles from 'assets/theme/views/admin/notifications.js'
import componentStylesDialog from 'assets/theme/components/dialog.js'

const useStyles = makeStyles(componentStyles)
const useStylesDialog = makeStyles(componentStylesDialog)

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction='down' ref={ref} {...props} />
})

function UploadImage(props) {
    const classes = { ...useStyles(), ...useStylesDialog() }
    const cropperRef = useRef(null)

    const [image, setImage] = useState(props.image ? props.image : null)
    const [showCropModal, setShowCropModal] = useState(false)
    const [uncroppedImage, setUncroppedImage] = useState(null)
    const [croppedImage, setCroppedImage] = useState(null)
    const isVideo = props.type === 'Video'

    const onDrop = useCallback(acceptedFiles => {
        const file = acceptedFiles[0]
        const preview = URL.createObjectURL(file)

        if (isVideo) {
            setImage(preview)
            props.updateImage(file)
        } else {
            setShowCropModal(true)
            setUncroppedImage(preview)
        }
    }, [isVideo, props])

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: isVideo ? 'video/mp4, video/webm, video/quicktime' : 'image/jpeg, image/png'
    })

    const onCrop = () => {
        const imageElement = cropperRef?.current
        const cropper = imageElement?.cropper
        cropper.getCroppedCanvas().toBlob(blob => {
            setCroppedImage(blob)
            setImage(cropper.getCroppedCanvas().toDataURL())
        })
    }

    const submitImage = () => {
        props.updateImage(croppedImage)
        setShowCropModal(false)
    }

    const brokenImage = () => setImage(null)

    return (
        <>
            {(image && !props.noPreview) ? (
                <div {...getRootProps()} className='dropzone'>
                    <input {...getInputProps()} />
                    {isVideo ? (
                        <video width='100%' controls>
                            <source src={image} type='video/mp4' />
                            Your browser does not support the video tag.
                        </video>
                    ) : (
                        <img onError={brokenImage} src={image} alt='Preview' />
                    )}
                </div>
            ) : (
                props.displayStyle === 'button' ? (
                    <div {...getRootProps()} className='dropzone'>
                        <input {...getInputProps()} />
                        <Button variant='contained' color='secondary'>
                            {props.uploadText || `Upload New ${isVideo ? 'Video' : 'Image'}`}
                        </Button>
                    </div>
                ) : props.displayStyle === 'box' ? (
                    <Box {...getRootProps()} className='dropzone' style={{
                        border: '2px dotted #888',
                        borderRadius: 8,
                        padding: '32px',
                        textAlign: 'center',
                        cursor: 'pointer',
                        background: '#fafbfc',
                        color: '#666',
                        fontSize: 16,
                        transition: 'border-color 0.2s',
                        margin: '8px 0',
                    }}>
                        <input {...getInputProps()} />
                        <span>{props.uploadText || `Click or drag to upload ${isVideo ? 'a video' : 'an image'}`}</span>
                    </Box>
                ) : (
                    <div {...getRootProps()} className='dropzone'>
                        <input {...getInputProps()} />
                        <p>{props.uploadText || `Click to upload ${isVideo ? 'a video' : 'an image'}`}</p>
                    </div>
                )
            )}

            {!isVideo && showCropModal && (
                <Dialog
                    open={showCropModal}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => setShowCropModal(false)}
                >
                    <div className={classes.dialogHeader}>
                        <Typography variant='h5' className={classes.dialogTitle}>Crop Image</Typography>
                        <IconButton onClick={() => setShowCropModal(false)}>
                            <Clear />
                        </IconButton>
                    </div>

                    <DialogContent>
                        <Cropper
                            src={uncroppedImage}
                            style={{ height: 400, width: '100%' }}
                            aspectRatio={props.flexible ? null : 1 / 1}
                            guides={true}
                            crop={onCrop}
                            ref={cropperRef}
                        />
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={() => setShowCropModal(false)} color='primary'>
                            Close
                        </Button>
                        <Button onClick={submitImage} color='primary' variant='contained'>
                            Submit Image
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    )
}

export default UploadImage